/**
 * Number of consecutive upload status polling failures tolerated before showing an error.
 * A single failed poll (network glitch, gateway timeout) does not mean the massive edit failed,
 * since the process keeps running on the backend.
 */
export const MAX_POLLING_RETRIES = 3;

/**
 * Extracts a readable error message from a failed response.
 * Supports the backend ApiErrorDto ({ typeError, message }) and plain text bodies.
 * @param {Response} response - The failed fetch response.
 * @returns {Promise<string|null>} The error message, or null if none can be extracted.
 */
export const readErrorMessage = async (response) => {
    let body;
    try {
        body = await response.text();
    } catch (e) {
        return null;
    }

    if (!body || !body.trim()) {
        return null;
    }

    try {
        const parsed = JSON.parse(body);
        if (parsed && typeof parsed.message === "string" && parsed.message.trim()) {
            return parsed.message;
        }
        if (parsed && typeof parsed.error === "string" && parsed.error.trim()) {
            return parsed.error;
        }
        return null;
    } catch (e) {
        // Not JSON: ignore HTML pages (e.g. gateway error pages), keep plain text
        return body.trim().startsWith("<") ? null : body;
    }
};
